import { createSelector } from "reselect";
import { isEmpty, forIn, isNull } from "lodash";

//EXTRACT THE PART OF THE STATE
const getData = state => state.profile.info;

//VERIFY IF THE JWT IS SET
const getMemberProfileRaw = createSelector(getData, userProfile => userProfile);
export default getMemberProfileRaw;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberProfileRaw.js